import { useOpenEditIntegrationTokenModal } from '../../../../../utils/routes/modals/modalsActions'

// export const onInstallService = (config, keepOrigin, integration, openModal) => {
export const onInstallService = (config, openModal) => {
  openModal('integrations/d4sign', config, 'Nova integração')

  return
}

export const useReinstallService = (config, openModal) => {
  const openTokenModal = useOpenEditIntegrationTokenModal()

  return ({ id }) => {
    openTokenModal({ service: config.key, integrationId: id })
  }
}
